import Vue from 'vue';
import Router from 'vue-router';
import home from '@/views/home';
import information from '@/views/Information';
import detail from '@/views/Information/Detail';
import course from '@/views/Course';
import Courdetail from '@/views/Course/Detail';
import video from '@/views/Course/Video';
import tryPlay from '@/views/Course/tryPlay';

import grade from '@/views/clazz';
//import functional from '@/views/clazz/functional';

import gradelist from '@/views/clazz/clazz-info';
import baoming from '@/views/clazz/baoming';

import exam from '@/views/Exam';
import startExam from '@/views/Exam/startExam';

import practiceindex from '@/views/Exam/practice';
import practicedetail from '@/views/Exam/practice/Exercise';
import examdetail from '@/views/Exam/Detail';
import examexercise from '@/views/Exam/Exercise';
import examexnotice from '@/views/Exam/Notice';
import teacher from '@/views/Teacher';
import teadetail from '@/views/Teacher/Detail';
import question from '@/views/Question';
import quesdetail from '@/views/Question/Detail';
import cooperation from '@/views/Cooperation';
import resource from '@/views/Resource';
import about from '@/views/About';
import our from '@/views/Our';
import perfectregister from '@/views/PerfectRegister';
import login from '@/views/Login';
import register from '@/views/Register';

import careerAssessment from '@/views/test/index';
import cert from '@/views/cert/index';
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);
//export default 
export default  new Router({
	mode: 'hash',
	//base:'student',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    routes: [
        // 当所有的路由路径不匹配的时候会重定到home页面
        {
		    path: '/',
		    name: 'home',
		    component: home,
			meta: {
			    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的*
			}
		},
		{
		    path: '/user/login',
		    name: 'login',
		    component: login,
			meta: {
			    requireAuth: false // 添加该字段，表示进入这个路由是需要登录的*
			}
		},
        {
            path: '/information',
            name: 'information',
            component: information,
        },
        {
            path: '/information/detail',
            name: 'detail',
            component: detail
        },
        {
            path: '/course',
            name: 'course',
            component: course,
        },
        {
            path: '/course/detail',
            name: 'Courdetail',
            component: Courdetail,
			meta: {
			    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
        },
        {
            path: '/course/video',
            name: 'video',
            component: video,
			meta: {
			    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
        },
		{
		    path: '/course/tryPlay',
		    name: 'tryPlay',
		    component: tryPlay,
			meta: {
				title:'试学课程',
			    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
		},
        {
            path: '/clazz',
            name: 'grade',
            component: grade,
        },
        {
            path: '/clazz/clazz-info',
            name: 'gradelist',
            component: gradelist,
        },
        {
            path: '/clazz/baoming',
            name: 'baoming',
            component: baoming,
			meta: {
			    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
        },
        {
            path: '/exam',
            name: 'exam',
            component: exam,
        },
		{
			path: '/startExam',
			name: 'startExam',
			component: startExam,
			meta: {
				keepAlive: false,
				requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
		},
        {
            path: '/exam/detail',
            name: 'examdetail',
            component: examdetail,
			meta: {
			    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
        },
		{
		    path: '/exam/practice',
		    name: 'practiceindex',
		    component: practiceindex,
			meta: {
			    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
		},
		{
		    path: '/exam/practice/exercise',
		    name: 'practicedetail',
		    component: practicedetail,
			meta: {
			    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
		},
        {
            path: '/exam/exercise',
            name: 'examexercise',
            component: examexercise,
			meta: {
			    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
        },	
        {
            path: '/exam/notice',
            name: 'examexnotice',
            component: examexnotice,
        },
        {
            path: '/teacher',
            name: 'teacher',
            component: teacher,
        },
        {
            path: '/teacher/detail',
            name: 'teadetail',
            component: teadetail,
        },
        {
            path: '/question',
            name: 'question',
            component: question,
        },
		//证书查询指引页面
		{
		    path: '/cert',
		    name: 'cert',
		    component: cert,
		},
        {
            path: '/question/detail',
            name: 'quesdetail',
            component: quesdetail,
			meta: {
			    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
        },
        {
            path: '/cooperation',
            name: 'cooperation',
            component: cooperation,
			meta: {
			    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
        },
        {
            path: '/resource',
            name: 'resource',
            component: resource,
        },
        {
            path: '/about',
            name: 'about',
            component: about,
        },
        {
            path: '/our',
            name: 'our',
            component: our,
			meta: {
			    requireAuth: true // 添加该字段，表示进入这个路由是需要登录的*
			}
        },
        {
            path: '/perfectregister',
            name: 'perfectregister',
            component: perfectregister,
        },
       
        {
            path: '/register',
            name: 'register',
            component: register,
        },
       {
            path: '/careerAssessment',
            name: 'careerAssessment',
            component: careerAssessment,
        }, 
    ],
});

